<template>
  <div class="field-of-fields container top-level-div" style="">
    <!-- {{ jobID }} -->
    <div v-if="job.id">
      <div v-if="job.status == 'Approved'">
        <h3 v-if="job.filler == $store.getters.userID">Thanks for filling this job!</h3>
        <h3 v-else>This job has been filled.</h3>
        <hr>
      </div>

      <h4>{{ job.title }}</h4>
      <hr>
      <p v-if="job.date">Start Date: {{ new Date(addCurrentTimeToDate(job.date)).toDateString() }}</p>
      <p v-if="job.text">Schedule: {{ job.text }}</p>
      <p>Location: {{ job.city }}, {{ job.provincestate }}, {{ job.postal_code }}</p>
      <p v-if="job.compensation">Compensation: {{ job.compensation }}</p>
      <p v-if="job.text">Schedule: {{ job.text }}</p>
      <pre class="mt-2" v-html="job.description"></pre>
      <hr>
      <!-- <p>{{ job.multiselect1 }}</p> -->
      <!-- <p>{{ employer.features2 }}</p> -->
      <!-- <div class="">
        <p v-if="publicEmployer.features2[0]">{{ publicEmployer.features2[0] }}, Age: {{ getAge(publicEmployer.features2[1]) }}</p>
        <p v-if="publicEmployer.features2[2]">{{ publicEmployer.features2[2] }}, Age: {{ getAge(publicEmployer.features2[3]) }}</p>
        <p v-if="publicEmployer.features2[4]">{{ publicEmployer.features2[4] }}, Age: {{ getAge(publicEmployer.features2[5]) }}</p>
        <p v-if="publicEmployer.features2[6]">{{ publicEmployer.features2[6] }}, Age: {{ getAge(publicEmployer.features2[7]) }}</p>
        <p v-if="publicEmployer.text_field1" class="mt-2">Family Pets: {{ publicEmployer.text_field1 }}</p>
      </div>
      <hr> -->
      <!-- <p v-if="fullAccess">{{ job.address1 }}</p> -->
      <!-- <p v-if="job.city">{{ job.city }}</p> -->
      <!-- <small v-if="job.postal_code" style="display: block;">{{ job.postal_code }}</small> -->
      <!-- <p v-if="job.postal_code" style="display: block;">{{ job.postal_code }}</p> -->
      <!-- <h4 v-if="job.country">{{ job.country }}</h4> -->
      <!-- <div>
        <small v-if="job.address1" style="display: block;">{{ job.address1 }}</small>
        <small v-if="job.address2" style="display: block;">{{ job.address2 }}</small>
        <small v-if="job.postal_code" style="display: block;">{{ job.postal_code }}</small>
      </div> -->

      <!-- <app-map v-if="job.city && !fullAccess" :locationObject="job" class="mt-2"></app-map> -->
      <!-- <app-map v-if="job.city && fullAccess" :locationObject="job" accessLevel="full" class="mt-2"></app-map> -->
      <app-map v-if="job.city" :locationObject="job" accessLevel="full" class="mt-2"></app-map>

      <!-- <div class="row pr-3">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-4" style="max-width: 175px;">
              <div v-if="employer.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg'">
                <router-link :to="{ name: 'Employer Public Profile', params: { id: employer.id } }">
                  <img :src="employer.profile_pic" style="max-height: 150px; max-width: 150px;">
                </router-link>
              </div>
            </div>
            <div class="col-lg-8 my-auto">
              <h2 v-if="job.status === 'draft'" class="mt-2">{{ job.title + " (Draft)"}}</h2>
              <h2 v-else class="mt-2">{{ job.title }}</h2>
              <h4 class="mt-2" v-if="employer.employer_name"><router-link :to="{ name: 'Employer Public Profile', params: { id: employer.id } }">{{ employer.employer_name }}</router-link></h4>
            </div>
          </div>

          <label v-if="job.description" class="shaded-label">Description</label>
          <div class="profile-section">
            <pre class="" v-html="job.description"></pre>
          </div>
        </div>
        <div class="col-lg-4 p-4" style="background-color: var(--bootstrapgrey)">
          <div v-if="job.id && employer.id">
            <label v-if="job.skills[0]" style="margin-top: 0;">Key Skills</label>
            <p v-if="job.skills[0]">{{ job.skills.join(', ') }}</p>
            <label v-if="job.skills2[0]">Topic Areas</label>
            <p v-if="job.skills2[0]">{{ job.skills2.join(', ') }}</p>
            <label v-if="job.compensation">Compensation</label>
            <p v-if="job.compensation">{{ job.compensation }}<span v-if="job.compensation_type"> ({{ job.compensation_type }})</span></p>
            <hr v-if="job.skills[0] || job.compensation">

            <p v-if="job.city">{{ job.city }}</p>
            <h4 v-if="job.country">{{ job.country }}</h4>
            <div>
              <small v-if="job.address1" style="display: block;">{{ job.address1 }}</small>
              <small v-if="job.address2" style="display: block;">{{ job.address2 }}</small>
              <small v-if="job.postal_code" style="display: block;">{{ job.postal_code }}</small>
            </div>

            <app-map v-if="job.city" :locationObject="job" class="mt-2"></app-map>

            <hr v-if="job.city">

            <label v-if="employer.organization_type" style="margin-top: 0;">Organization Type</label>
            <p>{{ employer.organization_type }}</p>
            <label v-if="employer.size">Organization Size</label>
            <p>{{ employer.size }}</p>

            <hr v-if="employer.organization_type || employer.size">

            <label v-if="job.application_deadline" style="margin-top: 0;">Application Deadline</label>
            <p v-if="job.application_deadline">{{ new Date(job.application_deadline).toDateString() }}</p>
            <div v-if="job.link && loggedinUser" class="mt-4 mb-3">
              <a :href="job.link" class="mylisting-button dark-button" target="_blank">APPLY</a>
            </div>
            <div class="mt-4 mb-3">
              <router-link v-if="!loggedinUser" :to="{ name: 'Candidate Registration' }" class="mylisting-button dark-button" style="text-align: center;">Apply</router-link>
            </div>

          </div>
        </div>
      </div> -->

      <!-- <div v-if="job.application_deadline || job.link">
        <label class="shaded-label">Application</label>
        <div class="row profile-section">
          <div class="col-lg-4">
            <label v-if="job.application_deadline">Application Deadline</label>
            <p>{{ new Date(job.application_deadline).toDateString() }}</p>
          </div>
          <div class="col-lg-8">
            <label v-if="job.link">Application Link</label>
          </div>
        </div>
      </div> -->

      <!-- <div v-if="loggedinUser == employer.id">
        <hr>
        <button class="mylisting-button danger-button" @click="deleteJob()">DELETE</button>
      </div>

      <div v-if="$store.getters.isAgent === 'true'">
        <hr>
        <button class="mylisting-button dark-button" @click="broadcastJob()">BROADCAST</button>
      </div> -->

      <!-- <div v-if="$store.getters.isAgent !== 'true'"> -->
        <hr>

      <div v-if="job.status != 'Approved'">
        <div v-if="$store.getters.isCandidate === true && loggedinUser.status ">
          <div v-if="!application.id" class="grouped-buttons">
            <button class="mylisting-button danger-button mb-3" @click="setApplicationStatus('Not Interested')">I'M NOT INTERESTED</button>
            <!-- <button class="mylisting-button secondary-button mb-3" @click="setApplicationStatus('Maybe')">I MIGHT BE INTERESTED</button> -->
            <button class="mylisting-button dark-button mb-3" style="float: right;" @click="setApplicationStatus('Interested')">I'M INTERESTED</button>
          </div>
          <h5 v-if="application.status == 'Not Interested'">Thanks for letting us know you aren't interested.</h5>
          <h5 v-if="application.status == 'Maybe'">Thanks for letting us know you might be interested, we'll be in touch if necessary!</h5>
          <h5 v-if="application.status == 'Interested'">Thanks for letting us know you are interested, we'll be in touch if it's a good fit!</h5>
          <!-- <h5 v-if="application.status == 'Accepted'">You have accepted this job! You can view it in your dashboard.</h5> -->
        </div>
        <!-- {{ application }} -->
      </div>

      <!-- </div> -->
    </div>

    <modal name="application-status-updated-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks for letting us know!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('application-status-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="job-accepted-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Congrats, you've accepted this job!</h2>
        <h5>All the details will appear here and in your dashboard.</h5>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-accepted-modal')" style="">Close</button>
      </div>
    </modal>

    <div v-if="!job.id && !timeToLoad">
      <h2>Loading job...</h2>
    </div>
    <div v-if="!job.id && timeToLoad">
      <!-- <h2>Sorry, job not found.</h2> -->
      <h2>Please wait, your job's loading.</h2>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import router from '../../router'

  import Map from '../global/Map.vue';

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        jobID: null,
        job: {},
        publicEmployer: {},
        employer: {},
        // loggedinUser: null,
        loggedinUser: {},
        jobTitle: '',
        application: {},

        timeToLoad: false,
      }
    },
    components: {
      appMap: Map,
    },
    computed: {
      fullAccess() {
        if (this.$store.getters.userID == this.job.filler || this.$store.getters.isAgent === true) {
          return true
        } else {
          return false
        }
      },
    },
    created () {
      this.jobID = this.$route.params.id
      // this.loggedinUser = this.$store.getters.userID
      this.getLoggedinUser()
      this.getJob()

      // If someone is logged in and is a candidate
      if (this.$store.getters.isCandidate === true) {
        this.getApplication()
      }

      // // https://www.npmjs.com/package/vue-loading-overlay
      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.formContainer,
      //   // container: this.$refs.formContainer,
      //   // canCancel: true,
      //   canCancel: false,
      //   // onCancel: this.onCancel,
      // });
      // // simulate AJAX
      // setTimeout(() => {
      //   loader.hide()
      //   this.timeToLoad = true
      // },2000)
    },
    methods: {
      getJob() {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
          this.timeToLoad = true
        },3000)

        axios.get('/api/jobs/?id='.concat(this.jobID.toString()))
          .then(res => {
            console.log(res.data)
            this.job = res.data[0]

            // console.log(this.job.title.concat(" (Draft)"))
            // this.job.title.concat(" (Draft)")

            //Changes page title to match job title
            // document.title = this.job.title

            //Updates the URL to show the job posting company and job title
            // this.$router.replace({ name: 'Job', params: {id: this.jobID.toString()}, query: {title: this.job.poster_name.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').split(/\s+/).join('-').concat('-'+this.job.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').split(/\s+/).join('-'))} })

            // axios.get('/api/people/'.concat(this.job.poster.toString()))
            axios.get('/api/publicemployers/?id='.concat(this.job.poster.toString()))
              .then(res => {
                // console.log(res.data)
                this.publicEmployer = res.data[0]
              })
              .catch(error => console.log(error))

            axios.get('/api/people/?id='.concat(this.job.poster.toString()))
              .then(res => {
                // console.log(res.data)
                this.employer = res.data[0]
              })
              .catch(error => console.log(error))
          })
          .catch(error => console.log(error))
      },
      getApplication() {
        axios.get(`/api/jobapplications/?job=${this.jobID}&applicant=${this.$store.getters.userID}`)
          .then(res => {
            if (res.data.length) {
              this.application = res.data[0]
            }
          })
          .catch(error => console.log(error))
      },
      getLoggedinUser() {
        axios.get(`/api/people/?id=${this.$store.getters.userID}`)
          .then(res => {
            this.loggedinUser = res.data[0]
          })
          .catch(error => console.log(error))
      },
      setApplicationStatus(status) {
        // axios.patch(`/api/jobapplications/${this.application.id}/`, {
        //   status: status,
        // })
        axios.post(`/api/jobapplications/`, {
          applicant: this.loggedinUser.id,
          applicant_name: `${this.loggedinUser.first_name} ${this.loggedinUser.last_name}`,
          job: this.job.id,
          job_title: this.job.title,
          status: status,
          agency_owner: this.$store.getters.agencyName,
          agency: this.$store.getters.agencyID,
        })
          .then(res => {
            // console.log(res)
            this.getApplication()
            this.$modal.show('application-status-updated-modal')

            this.$store.dispatch('sendEmails',
              {
                subject: `${this.job.title} - ${this.loggedinUser.first_name} (${status})`,
                message: 'Hello,' + '\n\n' +
                `New application submitted.\n` +
                `Job: ${this.job.title}\n` +
                `Nanny: ${this.loggedinUser.first_name} ${this.loggedinUser.last_name}\n` +
                `Status: ${status}`,
                from: this.$store.getters.agencyFromEmail,
                // emails: [this.$store.getters.enginehireAdminEmail, this.employer.selector9],
                emails: [this.$store.getters.enginehireLoggingEmail, this.employer.selector9],
                reply: this.$store.getters.agencyReplyEmail,
                userID: 4,
              }
            )

            // Increment the count on the number of declines or maybes
            // let statsArray = this.loggedinUser.numberArray
            // if (status == 'Not Interested') {
            //   statsArray[2] += 1
            // }
            // else if (status == 'Maybe') {
            //   statsArray[3] += 1
            // }
            // axios.patch(`/api/people/${this.loggedinUser.id}/`, {
            //   numberArray: statsArray
            // })
            //   .catch(error => console.log(error))
          })
          .catch(error => console.log(error))
      },
      acceptJob() {
        axios.patch(`/api/jobapplications/${this.application.id}/`, {
          status: 'Accepted',
        })
          .then(res => {
            this.getApplication()
            this.$modal.show('job-accepted-modal')
          })
          .catch(error => console.log(error))

        axios.patch(`/api/jobs/${this.jobID}/`, {
          status: 'Approved',
          filled: true,
          filler: this.$store.getters.userID,
          filler_name: this.application.applicant_name,
          filled_date: new Date,
        })
          .then(res => {
            this.getJob()
          })
          .catch(error => console.log(error))

        // Increment the count on the number of acceptances
        let statsArray = this.loggedinUser.numberArray
        statsArray[1] += 1
        axios.patch(`/api/people/${this.loggedinUser.id}/`, {
          numberArray: statsArray
        })
          .catch(error => console.log(error))
      },
      deleteJob() {
        // router.replace({name: 'Employer Dashboard'})
        axios.delete('/api/jobs/'.concat(this.jobID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            // router.replace('/organization')
            router.replace({name: 'Employer Dashboard'})
          })
          .catch(error => console.log(error))
      },
      broadcastJob() {
        axios.get('/api/people/?is_candidate=true&agency='+this.$store.getters.agencyID)
          .then(res => {
            console.log(res)
            for (var user in res.data) {
              axios
                .post("/optimum/message/", {
                  message: 'New Afternoon Nanny opportunity available, please go to nannyagency.ca/job/1345 to learn more.',
                  phone: res.data[user].phone,
                  user_id: res.data[user].id
                })
            }
          })
      }
    },
  }
</script>

<style>
  @media (max-width: 765px) {
    .grouped-buttons {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobBoard/Job.vue